import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, ExternalLink } from 'lucide-react'
import Header from '../components/Header'
import { usePlayer } from '../lib/player'

export default function About() {
  const { pause } = usePlayer()
  
  // Stop any playing music when entering the about page
  useEffect(() => {
    pause()
  }, [pause])

  return (
    <div className="h-full lg:overflow-y-auto pb-24">
      <Header />
      
      {/* Back link */}
      <nav className="max-w-3xl mx-auto px-4 pt-4">
        <Link 
          to="/"
          className="inline-flex items-center gap-1.5 text-surface-400 hover:text-surface-200 transition-colors text-sm"
        >
          <ArrowLeft size={16} />
          Back to search
        </Link>
      </nav>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-3xl md:text-4xl font-bold text-surface-50 mb-4">
          About
        </h1>
        
        <p className="text-surface-300 text-lg mb-8 leading-relaxed">
          Every NeurIPS 2025 paper, reimagined as a song. Find yours, share it, 
          have fun with it.
        </p>

        {/* Stats */}
        <section className="mb-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="glass-card rounded-xl p-4 text-center">
              <div className="text-2xl font-bold text-accent-400">5,978</div>
              <div className="text-surface-400 text-sm">Papers</div>
            </div>
            <div className="glass-card rounded-xl p-4 text-center">
              <div className="text-2xl font-bold text-accent-400">5,978</div>
              <div className="text-surface-400 text-sm">Songs</div>
            </div>
            <div className="glass-card rounded-xl p-4 text-center">
              <div className="text-2xl font-bold text-accent-400">~3 min</div>
              <div className="text-surface-400 text-sm">Each</div>
            </div>
            <div className="glass-card rounded-xl p-4 text-center">
              <div className="text-2xl font-bold text-accent-400">39</div>
              <div className="text-surface-400 text-sm">Genres</div>
            </div>
          </div>
        </section>

        {/* Credits */}
        <section className="mb-8">
          <p className="text-surface-400 text-sm">
            All songs created with{' '}
            <a
              href="https://suno.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent-400 hover:text-accent-300"
            >
              Suno
            </a>
            . Papers from the official NeurIPS 2025 proceedings.
          </p>
        </section>

        {/* Suno link */}
        <div>
          <a
            href="https://suno.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-surface-800 hover:bg-surface-700 rounded-lg text-surface-200 text-sm font-medium transition-colors"
          >
            <ExternalLink size={14} />
            Try Suno
          </a>
        </div>
      </main>
    </div>
  )
}
